import { useEffect, useState } from "react";
import { toast } from "sonner";
import { pwaSupported, enablePush, disablePush, pushEnabled } from "@/lib/pwa";
import { api } from "@/lib/api";
import { BellRing, Smartphone } from "lucide-react";

export default function PushSettings() {
  const [on, setOn] = useState(false);
  const [installEvt, setInstallEvt] = useState(null);
  useEffect(() => {
    pushEnabled().then(setOn);
    const h = (e) => { e.preventDefault(); setInstallEvt(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);
  const toggle = async () => {
    try {
      if (on) { await disablePush(); setOn(false); toast.success("Push notifications off"); }
      else { await enablePush(); setOn(true); toast.success("Push notifications on"); await api.post("/push/test"); }
    } catch (e) { toast.error(e.message || "Could not enable"); }
  };
  if (!pwaSupported()) return null;
  return (
    <div className="mt-4 flex flex-wrap gap-2 items-center" data-testid="push-settings">
      <button data-testid="push-toggle" onClick={toggle} className={`min-h-[44px] px-4 inline-flex items-center gap-2 rounded-xl font-medium transition-colors ${on ? "bg-emerald-brand text-white" : "border border-border hover:bg-secondary"}`}><BellRing size={16} /> {on ? "Push notifications on" : "Turn on push notifications"}</button>
      {installEvt && <button data-testid="install-app" onClick={async () => { installEvt.prompt(); setInstallEvt(null); }} className="min-h-[44px] px-4 inline-flex items-center gap-2 rounded-xl border border-border font-medium hover:bg-secondary"><Smartphone size={16} /> Add to home screen</button>}
      <span className="text-xs text-muted-foreground">Free 7-day and expiry-day nudges on your phone — no SMS needed.</span>
    </div>
  );
}
